import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card, CardBody, CardTitle, CardText,
  Container, Row, Col,
} from "reactstrap";
import { provincesRepo } from "data/repositories/provincesRepo";
import SearchBox from "components/SearchBox";
import ThemeBadge from "components/ThemeBadge";

export default function MapPage() {
  const [provinces, setProvinces] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setProvinces(provincesRepo.list());
  }, []);

  const filtered = provinces.filter((p) =>
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  const mapSrc =
    "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d2500000!2d37.5!3d41!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1str!2str";

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h2 className="text-white mb-0">Karadeniz Haritası</h2>
          <p className="text-white opacity-8">Haritayı keşfedin, illere tıklayın</p>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        {/* Map embed */}
        <Card className="shadow mb-4">
          <CardBody className="p-0">
            <iframe
              title="Karadeniz Haritası"
              src={mapSrc}
              width="100%"
              height="450"
              style={{ border: 0, borderRadius: "0.375rem" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </CardBody>
        </Card>

        {/* Search */}
        <SearchBox value={search} onChange={setSearch} placeholder="İl ara..." />

        {/* Province cards */}
        <Row>
          {filtered.map((p) => (
            <Col key={p.id} lg={4} md={6} xs={12} className="mb-4">
              <Card className="shadow" tag={Link} to={`/admin/provinces/${p.id}`} style={{ textDecoration: "none" }}>
                <CardBody>
                  <CardTitle tag="h4" className="mb-1">{p.name}</CardTitle>
                  <CardText className="text-muted small mb-2">{p.slogan}</CardText>
                  <div>
                    {(p.themes || []).slice(0, 3).map((t) => (
                      <ThemeBadge key={t} theme={t} />
                    ))}
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
}
